import React from 'react';
import { FormattedMessage } from 'react-intl';
import { N0, N40, N50, N800 } from '@atlaskit/theme/colors';
import Avatar from '@atlaskit/avatar';
import styled from 'styled-components';
import { JoinLinkItem } from './components/join-link-item';
import { fontFamily } from './font';
import { messages } from './messages';

export type JoinSiteUserLoggedInViewProps = {
  readonly userName: string;
  readonly userEmail: string;
  readonly onManageLicenses: () => void;
  readonly onManageProfile: () => void;
  readonly onLogOutClick: () => void;
  readonly onSwitchAccountClick: () => void;
  readonly avatarSrc?: string;
};

export function JoinSiteUserLoggedInView({
  userEmail,
  userName,
  onManageLicenses,
  onManageProfile,
  onLogOutClick,
  onSwitchAccountClick,
  avatarSrc
}: JoinSiteUserLoggedInViewProps) {
  return (
    <RootContainer>
      <TopRowContainer>
        <UserDetailsContainer>
          <Avatar
            src={avatarSrc}
            name={userName}
            size="small"
            enableTooltip={false}
            isDisabled={false}
            isFocus={false}
          />
          <UserInfoContainer>
            <UserNameLabel>{userName}</UserNameLabel>
            <UserEmailLabel>{userEmail}</UserEmailLabel>
          </UserInfoContainer>
        </UserDetailsContainer>
      </TopRowContainer>
      <LinkContainer>
        <JoinLinkItem
          linkLabel={<FormattedMessage {...messages.switchAccount} />}
          onLinkClick={onSwitchAccountClick}
        />
        <JoinLinkItem
          linkLabel={<FormattedMessage {...messages.profile} />}
          onLinkClick={onManageProfile}
        />
        <JoinLinkItem
          linkLabel={<FormattedMessage {...messages.licenses} />}
          onLinkClick={onManageLicenses}
        />
        <JoinLinkItem
          linkLabel={<FormattedMessage {...messages.logOut} />}
          onLinkClick={onLogOutClick}
        />
      </LinkContainer>
    </RootContainer>
  );
}

const RootContainer = styled.div`
  font-family: ${fontFamily};
  width: 250px;
`;

const TopRowContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid ${N40};
  margin-top: -4px;
  display: flex;
`;

const LinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: -4px;
`;

const UserDetailsContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 8px 16px;
  width: 100%;
  background-color: ${N800};
`;

const UserInfoContainer = styled.div`
  display: flex;
  flex-flow: column;
  margin-left: 8px;
`;

const UserNameLabel = styled.div`
  font-size: 15px;
  line-height: 19px;
  color: ${N0};
`;

const UserEmailLabel = styled.div`
  font-size: 10px;
  line-height: 12px;
  color: ${N50};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
